module.exports = __webpack_public_path__ + "static/media/Cctv_Cina.3f5f72bf.png";